

export type PsrItem = {
  displayName: string;
  type: 'medicalNeeds' | 'serviceNeeds';
  requiresExpiryDate: boolean;
  code: string;
  subCodesLabel?: string;
  description: string;
  subCode: string;
  subCodes: {
    displayName: string;
    subCode: string;
  }[] | null;
}


export type PsrCategory = {
  displayName: string,
  codes: PsrItem[]
}

export const psrConfig: PsrCategory[] = [{
  displayName: 'Personal circumstances',
  codes: [
    {
      code: '22',
      displayName: 'Additional presence preferred',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '03',
      displayName: 'Families with young children 5 or under',
      description:
        'There could be one or more children, living in your household who are currently 5 or under 5 years old. You will be treated as priority customer until the date the child turns 6 or if more than 1 child, the date the youngest child turns 6.',
      requiresExpiryDate: true,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '01',
      displayName: 'Pensionable age',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '19',
      displayName: 'Temporary - Life changes',
      description:
        'Temporary changes could include bereavement, divorce and redundancy or anything that could make it hard coping with everyday life situations. It could also include having to consider/learn to manage household responsibilities that you have previously not had to do.',
      requiresExpiryDate: true,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '20',
      displayName: 'Temporary - Post hospital recovery',
      description:
        "Post hospital recovery includes returning home for a period of time to recuperate after major surgery or a hospital stay, with the assumption that you'll make a near/full recovery. Some examples are knee surgery or hip replacement.",
      requiresExpiryDate: true,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '21',
      displayName: 'Temporary - Young adult householder(<18)',
      description:
        'A young adult householder is anyone under the age of 18 living independently. They may have been in foster care, have a limited support network, or be under 18 and a parent / guardian of young children.',
      requiresExpiryDate: true,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
  ]
},
{
  displayName: 'Sensory and communication',
  codes: [
    {
      code: '08',
      displayName: 'Blind',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '05',
      displayName: 'Hearing impairment (inc. Deaf)',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '07',
      displayName: 'Partially sighted',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '12',
      displayName: 'Poor sense of smell',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '14',
      displayName: 'Speech Difficulties',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '15',
      displayName: 'Unable to communicate in English',
      description:
        'If anyone living in the home is unable to communicate well in English, please tell us the languages they speak.',
      requiresExpiryDate: false,
      subCodesLabel: 'If anyone living in the home is unable to communicate well in English, please tell us the language they speak.',
      type: 'serviceNeeds',
      subCode: '',
      subCodes: [
        {
          subCode: 'a',
          displayName: 'English (English or Welsh if in Wales)',
        },
        {
          subCode: 'b',
          displayName: 'Polish',
        },
        {
          subCode: 'c',
          displayName: 'Panjabi',
        },
        {
          subCode: 'd',
          displayName: 'Urdu',
        },
        {
          subCode: 'e',
          displayName: 'Bengali (with Sylheti and Chatgaya)',
        },
        {
          subCode: 'f',
          displayName: 'Gujarati',
        },
        {
          subCode: 'g',
          displayName: 'Arabic',
        },
        {
          subCode: 'h',
          displayName: 'French',
        },
        {
          subCode: 'i',
          displayName: 'All other Chinese',
        },
        {
          subCode: 'j',
          displayName: 'Portuguese',
        },
        {
          subCode: 'k',
          displayName: 'Spanish',
        },
        {
          subCode: 'l',
          displayName: 'Tamil',
        },
        {
          subCode: 'm',
          displayName: 'Turkish',
        },
        {
          subCode: 'n',
          displayName: 'Italian',
        },
        {
          subCode: 'o',
          displayName: 'Somali',
        },
        {
          subCode: 'p',
          displayName: 'Lithuanian',
        },
        {
          subCode: 'q',
          displayName: 'German',
        },
        {
          subCode: 'r',
          displayName: 'Persian/Farsi',
        },
        {
          subCode: 's',
          displayName: 'Tagalog/Filipino',
        },
        {
          subCode: 't',
          displayName: 'Romanian',
        },
        {
          subCode: 'u',
          displayName: 'Welsh',
        },
        {
          subCode: 'v',
          displayName: 'Deaf',
        },
        {
          subCode: 'w',
          displayName: 'Sign',
        },
        {
          subCode: 'x',
          displayName: 'Unknown',
        },
      ],
    },
  ]
},
{
  displayName: 'Mobility',
  codes: [
    {
      code: '13',
      displayName: 'Arthritis',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '11',
      displayName: 'Confined to bed',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: 'c',
      subCodes: null,
    },
    {
      code: '11',
      displayName: 'Poor mobility',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: 'd',
      subCodes: null,
    },
    {
      code: '11',
      displayName: 'Restricted hand movement',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: 'b',
      subCodes: null,
    },
    {
      code: '11',
      displayName: 'Unable to answer door',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: 'e',
      subCodes: null,
    },
    {
      code: '11',
      displayName: 'Wheelchair user',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: 'a',
      subCodes: null,
    },
  ]
},
{
  displayName: 'Cognitive',
  codes: [
    {
      code: '16',
      subCode: 'a',
      displayName: "Autism / Asperger's",
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '16',
      subCode: 'c',
      displayName: 'Learning Difficulties (Inc. dyslexia)',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '10',
      displayName: 'Dementia(s)',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      code: '09',
      displayName: 'Mental health',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
    {
      subCode: 'b',
      displayName: 'Tourette Syndrome',
      code: '16',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
  ]
},
{
  displayName: 'Chronic/serious illness',
  codes: [
    {
      code: '04',
      subCode: 'd',
      displayName: 'Asthma',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'e',
      displayName: 'COPD',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'a',
      displayName: 'Cancer',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'g',
      displayName: 'Cystic Fibrosis',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'h',
      displayName: 'Diabetes',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'c',
      displayName: 'Heart condition',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'b',
      displayName: 'Leukaemia',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
    {
      code: '04',
      subCode: 'f',
      displayName: 'Lung Disease',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCodes: null,
    },
  ]
},
{
  displayName: 'Medical dependencies',
  codes: [
    {
      code: '35',
      displayName: 'Careline or Telecare system',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '31',
      displayName: 'Dialysis, feeding pump or automated medication',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '30',
      displayName: 'Heart, lung and ventilator',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '34',
      displayName: 'Medically dependent showering/bathing',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '36',
      displayName: 'Medicine refrigeration',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '33',
      displayName: 'Nebuliser and apnoea monitor',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '32',
      displayName: 'Oxygen concentrator',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '38',
      displayName: 'Oxygen Use',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '37',
      displayName: 'Stair lift, hoist, electric bed',
      type: 'medicalNeeds',
      description: '',
      requiresExpiryDate: false,
      subCode: '',
      subCodes: null,
    },
    {
      code: '23',
      displayName: 'Water dependent',
      description: '',
      requiresExpiryDate: false,
      type: 'serviceNeeds',
      subCode: '',
      subCodes: null,
    },
  ]
}]